import { Container, Box, Typography, IconButton } from "@mui/material";
import LinkWrapper from "../LinkWrapper/LinkWrapper";
import { Link } from "react-router-dom";
import { Instagram, Facebook } from "@mui/icons-material";

/**
 * Footer section
 */
export const Footer = () => {
  return (
    <footer style={{ backgroundColor: "#f9f9f9" }}>
      <Container
        maxWidth="lg"
        sx={{
          paddingY: "2.5rem",
          paddingX: { xs: "1rem", sm: "2rem", md: "4rem" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            marginBottom: "28px",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              width: { xs: "50%", sm: "50%", md: "fit-content" },
              marginBottom: "2rem",
            }}
          >
            <Box display="flex" flexDirection="column" gap={0.5}>
              <Typography variant="subtitle1">Get to know us</Typography>
              <LinkWrapper
                visitorUrl="/sign-up"
                freeUserUrl="/shirts-collections"
                premiumUserUrl="/shirts-collections"
                component={
                  <Typography variant="footerElement">
                    Shirts and Collections
                  </Typography>
                }
              />
              <LinkWrapper
                visitorUrl="/sign-up"
                freeUserUrl="/community"
                premiumUserUrl="/community"
                component={
                  <Typography variant="footerElement">Community</Typography>
                }
              />
              <LinkWrapper
                visitorUrl="/sign-up"
                freeUserUrl="/store"
                premiumUserUrl="/store"
                component={
                  <Typography variant="footerElement">Store</Typography>
                }
              />
            </Box>
          </Box>
          <Box
            sx={{
              width: { xs: "50%", sm: "50%", md: "fit-content" },
              marginBottom: "2rem",
            }}
          >
            <Box display="flex" flexDirection="column" gap={0.5}>
              <Typography variant="subtitle1">Help</Typography>
              <Link to="/faq">
                <Typography variant="footerElement">FAQ</Typography>
              </Link>
              <Link to="/upgrade-membership">
                <Typography variant="footerElement">Subscriptions</Typography>
              </Link>
              <Link to="/contact-us">
                <Typography variant="footerElement">Contact us</Typography>
              </Link>
            </Box>
          </Box>

          <Box
            sx={{
              width: { xs: "50%", sm: "50%", md: "fit-content" },
              marginBottom: "2rem",
            }}
          >
            <Box display="flex" flexDirection="column" gap={0.5}>
              <Typography variant="subtitle1">Policies</Typography>
              <Link to="/terms-and-conditions">
                <Typography variant="footerElement">Terms of use</Typography>
              </Link>
              <Link to="/privacy-policy">
                <Typography variant="footerElement">Privacy Policy</Typography>
              </Link>
              <Link to="/cookie-policy">
                <Typography variant="footerElement">Cookie Policy</Typography>
              </Link>
            </Box>
          </Box>

          <Box
            sx={{
              width: { xs: "50%", sm: "50%", md: "fit-content" },
              marginBottom: "2rem",
            }}
          >
            <Box display="flex" flexDirection="column" gap={0.5}>
              <Typography variant="subtitle1">Join Community</Typography>
              <Box>
                <Link to="https://www.instagram.com/we.are.collecticos?igsh=MW15ZG9paG9md2F3dQ%3D%3D&utm_source=qr">
                  <IconButton
                    className="default-btn move-right"
                    sx={{
                      borderRadius: "5px !important",
                      height: "40px",
                      width: "40px",
                      marginRight: "8px",
                    }}
                  >
                    <Instagram
                      style={{
                        fontSize: 24,
                        color: "white",
                        position: "relative",
                        zIndex: "1",
                      }}
                    />
                  </IconButton>
                </Link>

                <Link to="https://www.facebook.com/profile.php?id=61573266723151">
                  <IconButton
                    className="default-btn move-right"
                    sx={{
                      borderRadius: "5px !important",
                      height: "40px",
                      width: "40px",
                    }}
                  >
                    <Facebook
                      style={{
                        fontSize: 24,
                        color: "white",
                        position: "relative",
                        zIndex: "1",
                      }}
                    />
                  </IconButton>
                </Link>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          display="flex"
          justifyContent="center"
          maxWidth={1200}
          mx="auto"
          columnGap={2}
        >
          <Typography variant="footerElement">
            © Collecticos B.V. 2025
          </Typography>
        </Box>
      </Container>
    </footer>
  );
};

export default Footer;
